import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Loader from "./components/Loader";
import Home from "./pages/Home/Home";
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Portfolio from './pages/Portfolio';
import Navbar from "./components/Navbar";
import Footer from "./pages/Footer";
import ServicesPage from "./pages/ServicesPage";
import CareerPage from "./pages/CareerPage";
import BlogDetail from "./pages/BlogDetail";
import Blog from "./pages/Blog";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";


function App() {
  const [loading, setLoading] = useState(true);

  if (loading) {
    return <Loader onFinish={() => setLoading(false)} />;
  }

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:page" element={<Blog />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />

      </Router>
    </HelmetProvider>
  );
}

export default App;
